import { setStep } from "../../redux/payment/slice";
import { PAYMENT_STEPS } from "../../types/PaymentMethodsTypes";

export const redirectToUrl = (dataKey, data, dispatch) => {
  if (data[dataKey]) {
    window.open(data[dataKey], "_self");
  } else {
    dispatch(setStep(PAYMENT_STEPS.FAILED));
  }
};
